<template>
	<VCard
		theme="dark"
		class="exchange-public-athlete-profile-rate-card border"
	>
		<template #title>
			<div class="d-flex align-center justify-space-between">
				<VBtn
					size="small"
					:icon="RATE_TYPES[rateCard.transactionTypeId].icon"
					:color="RATE_TYPES[rateCard.transactionTypeId].color"
					class="pointer-events-none"
				/>
				<div
					v-format-cents-to-dollars="rateCard.cost"
					class="font-weight-bold text-h2"
				/>
			</div>
		</template>
		<template #default>
			<div class="px-4">
				<div class="font-weight-bold text-high-emphasis">
					{{ rateCard.transactionType }}
				</div>
				<div class="text-body-2">
					{{ rateCard.title }}
				</div>
				<div class="mt-1 text-body-2">
					{{ rateCard.description }}
				</div>
			</div>
		</template>
		<template #actions>
			<VBtnPrimary
				class="text-decoration-none"
				block
				:href="`${localExchangeUrl}?athleteUuid=${athleteUuid}&rateSheetUuid=${rateCard.uuid}`"
			>
				{{ t('selectOffer') }}
			</VBtnPrimary>
		</template>
	</VCard>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { SingleExchangeAthleteRateCard } from '@/types/exchangeAthletes';
import vFormatCentsToDollars from '@/directives/formatCentsToDollars';

defineProps<{
	athleteUuid: string;
	localExchangeUrl: string;
	rateCard: SingleExchangeAthleteRateCard;
}>();

const { t } = useI18n();

const RATE_TYPES: Record<number, { icon: string; color: string }> = {
	1: { icon: 'handshake', color: '#528bff' },
	2: { icon: 'alternate_email', color: '#a48afb' },
	3: { icon: 'fitness_center', color: '#f670c7' },
	4: { icon: 'edit', color: '#f38744' },
	5: { icon: 'work', color: '#3ccb7f' },
	6: { icon: 'business', color: '#85e13a' },
	7: { icon: 'gavel', color: '#717bbc' },
	8: { icon: 'attach_money', color: '#8098f9' },
	9: { icon: 'star', color: '#fac515' },
	10: { icon: 'attach_money', color: '#8098f9' },
};
</script>
